import { ssoApi } from "@sso/apis";
import { ApiMethodKeys, EntityName, notificationsMsgs, SnackbarKeys } from "@sso/constant";
import { closeDialog } from "@sso/store/slices/dialog";
import { pushSnackbar } from "@sso/store/slices/snackbar";
import { ApiPageResponse, UserForm, UserList, UserLight } from "@sso/types";

import { CacheKeys } from "../cacheKeys";
import { Endpoints } from "../endpoints";

export const usersApi = ssoApi.enhanceEndpoints({ addTagTypes: [CacheKeys.USERS, CacheKeys.ORGS] }).injectEndpoints({
  endpoints: builder => ({
    users: builder.query<ApiPageResponse<UserList>, string>({
      query: query => ({ url: `${Endpoints.USERS}?${query}` }),
      providesTags: [CacheKeys.USERS],
    }),
    usersByUserOrg: builder.query<UserLight[], null | number | void>({
      query: (orgId = null) => ({ url: orgId != null ? `${Endpoints.USERS}/GetByUserOrg?orgId=${orgId}` : `${Endpoints.USERS}/GetByUserOrg` }),
    }),
    addUser: builder.mutation<void, UserForm>({
      query: data => ({ url: `${Endpoints.USERS}/create`, method: ApiMethodKeys.POST, data }),
      invalidatesTags: [CacheKeys.USERS, CacheKeys.ORGS],
      onQueryStarted(_, { dispatch, queryFulfilled }) {
        queryFulfilled.then(() => {
          dispatch(pushSnackbar({ type: SnackbarKeys.SUCCESS, title: notificationsMsgs.ADD_ITEM(EntityName.USER) }));
          dispatch(closeDialog());
        });
      },
    }),
    editUser: builder.mutation<void, UserForm>({
      query: data => ({ url: `${Endpoints.USERS}/update`, method: ApiMethodKeys.PUT, data }),
      invalidatesTags: [CacheKeys.USERS],
      onQueryStarted(_, { dispatch, queryFulfilled }) {
        queryFulfilled.then(() => {
          dispatch(pushSnackbar({ type: SnackbarKeys.SUCCESS, title: notificationsMsgs.Edit_ITEM(EntityName.USER) }));
          dispatch(closeDialog());
        });
      },
    }),
    deleteUser: builder.mutation<void, string>({
      query: userId => ({ url: Endpoints.USERS, params: { userId }, method: ApiMethodKeys.DELETE }),
      invalidatesTags: [CacheKeys.USERS],
      onQueryStarted(_, { dispatch, queryFulfilled }) {
        queryFulfilled.then(() => {
          dispatch(pushSnackbar({ type: SnackbarKeys.SUCCESS, title: notificationsMsgs.DELETE_ITEM(EntityName.USER) }));
          dispatch(closeDialog());
        });
      },
    }),
  }),
});

export const { useUsersQuery, useUsersByUserOrgQuery, useAddUserMutation, useEditUserMutation, useDeleteUserMutation } =
  usersApi;
